import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {from, Observable, switchMap} from 'rxjs';
import {environment} from '../../environments/environment';

export interface PlanView {
  planId?: string;
  code: string;
  name: string;
  maxListings: number;
  priceMonthlyCents: number;
  stripePriceId?: string;
}

export interface SubscriptionView {
  plan?: PlanView;
  status: string;
  activeListings: number;
  maxListings: number;
  canCreateListing: boolean;
}

export interface SubscriptionCheckoutResult {
  mode: string;
  checkoutUrl?: string;
  message?: string;
  planCode?: string;
}

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  constructor(private http: HttpClient) {}

  listPlans(): Observable<PlanView[]> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.get<PlanView[]>(`${env.backendURL}/api/subscriptions/plans`)
      )
    );
  }

  getMe(): Observable<SubscriptionView> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.get<SubscriptionView>(`${env.backendURL}/api/subscriptions/me`)
      )
    );
  }

  checkout(planCode: string): Observable<SubscriptionCheckoutResult> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post<SubscriptionCheckoutResult>(`${env.backendURL}/api/subscriptions/checkout`, {
          planCode
        })
      )
    );
  }
}
